import { render, staticRenderFns } from "./ExternalConnectionHistory.vue?vue&type=template&id=772e2efd&"
import script from "./ExternalConnectionHistory.vue?vue&type=script&lang=js&"
export * from "./ExternalConnectionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports